import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function EstimatedTradeCostComparisonHelp() {
    return (
        <IconTooltip>
            <div>
                This widget provides Cost and Risk for an order selection across
                a range of Benchmark and Profile combinations set up by the
                user.
            </div>
            <div>
                The widget uses our MAS Optimiser to estimate impact and risk
                for a given quantity (including any constraints). An optimal end
                time is also returned.
            </div>
            <div>
                Up to 6 comparisons can be configured in the widget settings.
                Each comparison is a benchmark and profile combination, along
                with other parameters such as Lit Participation and Strike Time.
            </div>
            <div>
                The left hand panel shows the symbol and remaining quantity
                (which is used in the calculation). You can change the quantity
                by clicking the edit button. When the layout is unlocked you can
                hide/show this panel by hovering over it and clicking the arrow
                buttons.
            </div>
            <div>The results grid supports sorting and has a column picker</div>
        </IconTooltip>
    );
}
